import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { ZonaGeografica } from 'src/app/models/zona-geografica';
import { ZonaGeograficaService } from 'src/app/services/zona-geografica.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditZonaGeograficaComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'zone-geografiche',
  templateUrl: './zone-geografiche.component.html',
  styleUrls: ['./zone-geografiche.component.scss']
})
export class ZoneGeograficheComponent implements OnInit {


  headingText: string = 'Zone geografiche';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Descrizione',
        internalName: 'descrizione',
      }
    ),

  ];
  constructor(public zonaGeograficaService: ZonaGeograficaService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<ZoneGeograficheComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona una zona geografica';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (zonaGeografica: ZonaGeografica) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare la zona geografica ${zonaGeografica.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.zonaGeograficaService.delete(zonaGeografica);
          this.toast.success('Zona geografica eliminata.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione zona geografica fallita.", "Errore!");
    }
  }



  editFunction = async (zonaGeografica: ZonaGeografica) => {
    try {
      let dialogRef = this.dialog.open(EditZonaGeograficaComponent, { data: zonaGeografica });
      dialogRef.afterClosed().subscribe(async (data: ZonaGeografica) => {
        if (data) {

          Object.assign(zonaGeografica, data);

          await this.zonaGeograficaService.edit(zonaGeografica);

          this.toast.success('Zona geografica modificata');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica zona geografica fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditZonaGeograficaComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(zonaGeografica?: ZonaGeografica) {
    if (zonaGeografica) {
      try {
        await this.zonaGeograficaService.create(zonaGeografica)
        this.toast.success('Zona geografica creata!')
      }
      catch (e) {
        this.toast.error('Creazione zona geografica fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
